(function () {
  'use strict';

  function qualifyMoney(value) {
    var body = document.body;
    var currency = (body && body.dataset.activeCurrency || '').toUpperCase();
    var country = (body && body.dataset.activeCountry || '').toUpperCase();
    var prefix = {
      CAD: 'CA',
      AUD: 'A',
      NZD: 'NZ',
      SGD: 'S',
      HKD: 'HK',
      MXN: 'MX'
    }[currency] || '';

    if (currency === 'USD' && country !== 'US') prefix = 'US';
    if (!prefix || typeof value !== 'string' || value.indexOf(prefix + '$') !== -1) return value;
    return value.replace('$', prefix + '$');
  }

  function patchMoneyFormatter() {
    if (!window.theme || !theme.Currency || !theme.Currency.formatMoney || theme.Currency.__celzoirPatched) return false;
    var original = theme.Currency.formatMoney;
    theme.Currency.formatMoney = function () {
      return qualifyMoney(original.apply(theme.Currency, arguments));
    };
    theme.Currency.__celzoirPatched = true;
    return true;
  }

  function updateSaleBadge(variant) {
    var badge = document.querySelector('.product-single__meta [data-save-price]');
    if (!badge || !variant) return;
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (!onSale) {
      badge.classList.add('hide');
      badge.textContent = '';
      return;
    }
    var percent = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
    badge.classList.remove('hide');
    badge.innerHTML = '<span class="celzoir-pdp-sale-label__prefix">LAST DAY |</span><span class="celzoir-pdp-sale-label__value">-' + percent + '%</span><span class="celzoir-pdp-sale-label__suffix">OFF</span>';
  }

  function initSticky() {
    var sticky = document.querySelector('[data-celzoir-sticky-atc]');
    var stickyButton = sticky && sticky.querySelector('[data-celzoir-sticky-button]');
    var mainButton = document.querySelector('.product-single__meta [data-add-to-cart]');
    var productMeta = document.querySelector('.product-single__meta');
    if (!sticky || !stickyButton || !mainButton || !productMeta || sticky.dataset.bound) return;
    sticky.dataset.bound = 'true';

    var suppressed = false;
    var description = document.querySelector('.product-single__description');
    if (!description) {
      description = Array.prototype.slice.call(
        document.querySelectorAll('.product-single__meta .product-block > .rte')
      ).filter(function (candidate) {
        return candidate.querySelector('h1, h2, h3') &&
          candidate.textContent.trim().length > 120;
      }).sort(function (left, right) {
        return right.textContent.trim().length - left.textContent.trim().length;
      })[0];
    }
    if (!description) return;

    function update() {
      var descriptionTop = description.getBoundingClientRect().top + window.scrollY;
      var trigger = descriptionTop + description.offsetHeight * 0.55;
      var viewportMiddle = window.scrollY + window.innerHeight * 0.55;
      var show = window.innerWidth <= 768 && viewportMiddle >= trigger && !suppressed;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    function activate(event) {
      event.preventDefault();
      suppressed = true;
      sticky.classList.remove('is-visible');
      sticky.setAttribute('aria-hidden', 'true');
      var top = productMeta.getBoundingClientRect().top + window.scrollY - 8;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      window.setTimeout(function () {
        mainButton.focus({ preventScroll: true });
        suppressed = false;
        update();
      }, 650);
    }

    stickyButton.addEventListener('click', activate);
    stickyButton.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') activate(event);
    });
  }

  function initAnnouncementSticky() {
    var bar = document.querySelector('.celzoir-announcement');
    if (!bar || bar.dataset.stickyBound) return;
    bar.dataset.stickyBound = 'true';

    var placeholder = document.createElement('div');
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.height = '0px';
    bar.parentNode.insertBefore(placeholder, bar);

    function update() {
      var threshold = placeholder.getBoundingClientRect().top + window.scrollY;
      var fixed = window.scrollY >= threshold;
      bar.classList.toggle('is-fixed', fixed);
      placeholder.style.height = fixed ? bar.offsetHeight + 'px' : '0px';
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAvailability(widget) {
    if (!widget || widget.dataset.celzoirReady) return;
    var modal = widget.querySelector('[data-celzoir-store-modal]');
    var opener = widget.querySelector('[data-celzoir-store-open]');
    var closer = widget.querySelector('[data-celzoir-store-close]');
    var city = widget.querySelector('[data-celzoir-store-city]');
    var label = widget.querySelector('[data-celzoir-store-city-label]');
    var result = widget.querySelector('[data-celzoir-store-city-result]');
    var previousFocus;
    widget.dataset.celzoirReady = 'true';
    function close() {
      modal.hidden = true;
      document.body.classList.remove('celzoir-store-modal-open');
      if (previousFocus) previousFocus.focus();
    }
    if (opener) opener.addEventListener('click', function () {
      previousFocus = opener;
      modal.hidden = false;
      document.body.classList.add('celzoir-store-modal-open');
      if (closer) closer.focus();
    });
    if (closer) closer.addEventListener('click', close);
    if (modal) modal.addEventListener('click', function (event) { if (event.target === modal) close(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && modal && !modal.hidden) close(); });
    if (city) city.addEventListener('change', function () {
      label.textContent = city.value;
      result.textContent = "Product not available in {{ city }}.".replace("{{ city }}", city.value);
    });
  }

  function start() {
    patchMoneyFormatter();
    initSticky();
    initAnnouncementSticky();
    Array.prototype.forEach.call(document.querySelectorAll('[data-celzoir-store-availability]'), initAvailability);
    window.setTimeout(patchMoneyFormatter, 100);
  }

  document.addEventListener('variant:change', function (event) {
    window.setTimeout(function () {
      updateSaleBadge(event.detail && event.detail.variant);
    }, 0);
  });
  document.addEventListener('shopify:section:load', start);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
